import styled from 'styled-components';

export const CategoriesPageContainer = styled.div`
	width: 100%;
	padding: 2.5rem 1rem;

	.breadcrumbs {
		margin-bottom: 2rem;
	}

	.header {
		margin-bottom: 2rem;
	}

	.container {
		max-width: 1084px;
		width: 100%;
		margin: 0 auto;
	}

	.category {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.25rem;
		padding: 1rem;
		cursor: pointer;
	}

	.title {
		margin-bottom: 0.25rem;
	}

	.meta-text {
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}
`;
